const Checkbox = ({
  wrapperClassName = "",
  checkboxClassName = "",
  id = "",
  name = "",
  label = "",
  change = () => {},
  value = "",
  ariaLabel = "",
  disabled,
}) => {
  function onChange(e) {
    change(e.target.checked);
  }
  return (
    <div className={`checkbox-component form-check ${wrapperClassName}`}>
      <input
        className={`form-check-input ${checkboxClassName}`}
        type="checkbox"
        value=""
        id={id}
        name={name}
        onChange={onChange}
        checked={value}
        aria-label={ariaLabel}
        disabled={disabled}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
